import React from 'react';
import { ButtonGroup, Menu, MenuItem } from '@mui/material';
import { Button } from '../Button/Button';
import { Icon } from '../Icon/Icon';
import { WBTooltip } from '../..';

export interface SplitButtonOption {
  label: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  tooltip?: React.ReactNode;
}

export interface SplitButtonProps {
  mainAction: SplitButtonOption;
  options: SplitButtonOption[];
  disabled?: boolean;
  loading?: boolean;
}

export const SplitButton: React.FC<SplitButtonProps> = ({
  mainAction,
  options,
  disabled,
  loading,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuItemClick = (action: SplitButtonOption) => {
    if (action.disabled) {
      return;
    }
    action.onClick();
    setAnchorEl(null);
  };

  return (
    <>
      <ButtonGroup
        variant="outlined"
        disabled={disabled}
        aria-label="split button"
      >
        <Button
          variant="outlined"
          color="primary"
          onClick={mainAction.onClick}
          loading={loading}
          disabled={disabled}
        >
          {mainAction.label}
        </Button>
        <Button
          variant="outlined"
          color="primary"
          disabled={disabled || loading}
          type="button"
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          <Icon name="ChevronDown" />
        </Button>
      </ButtonGroup>
      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        {options.map((option, idx) => (
          <MenuItem
            key={idx}
            disabled={option.disabled}
            onClick={() => handleMenuItemClick(option)}
          >
            {option.tooltip ? (
              <WBTooltip title={option.tooltip}>
                <span>{option.label}</span>
              </WBTooltip>
            ) : (
              option.label
            )}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default SplitButton;
